import { BpModalCanDismiss } from "@models/interfaces/bp-modal-can-dismiss";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";
import { Helper } from "@helpers/functions";
import { TranslationService } from "@core-services/translation.service";
import { config } from "@config";
import { AccountService } from "../../../account/services/account.service";
import { BEST_SYMBOL, BEST_TWO_TERMS_ON_HOLD } from "@helpers/constants";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	templateUrl: "./best2-modal.component.html",
	styleUrls: ["./best2-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class Best2ModalComponent extends CustomModal implements BpModalCanDismiss, OnInit {
	private canClose: boolean = false;

	public constructor(
		protected translationService: TranslationService,
		private accountService: AccountService
	) {
		super();
	}

	public ngOnInit(): void {
		this.accountService.accountUpdated.pipe(untilDestroyed(this)).subscribe((account) => {
			if (account.isBest2TermsAccepted()) {
				this.close();
			}
		});
	}

	public onLater(): void {
		Helper.setCookie(BEST_TWO_TERMS_ON_HOLD, "true");
		this.close();
	}

	public onAccept(): void {
		this.accountService.account.acceptBest2Terms();
		this.accountService.update();
	}

	public modalCanDismiss(): boolean {
		// Cannot be dismissed until one of the actions is clicked
		return this.canClose;
	}

	public close(): void {
		this.canClose = true;
		super.close();
	}

	public getTermsLink(): string {
		// Link only exists as de or en version, en is default
		const language: string = TranslationService.getLanguageIsoCode() === "de" ? "de" : "en";
		return config.baseUrl + language + config.externalPaths[BEST_SYMBOL]["best_two_legal"];
	}
}
